var dialog = require('../../dialog'),
    minicart = require('../../minicart'),
    page = require('../../page'),
    util = require('../../util'),
    image = require('./image'),
	tealium = require('../../../../../int_tealium/cartridge/js/tealium/tealium'),
	internationalshipping = require('../../internationalshipping'),
    Promise = require('promise'),
    _ = require('lodash');

var cartOverlay = {
	    /**
	     * @function
	     * @description Appends a dialog to a given container (target)
	     * @param {Object} params  params.target can be an id selector or an jquery object
	     */
	    openCartOverlay: function (params,responses) {
	    	var dialogtitle =$(params).find('.cart-overlay-title').val();
	    	var overlayContent = $(params).find('.cart-overlay-html');
	    	var totalUpdatedPriceQty = $(params).find('.addtocartoverlay-subtotals').html();
	    	var data = $(overlayContent).find('.addtocartoverlay-products').data('addtocart') || {};
	    	var prodID = '';
	    	var dataContent = "<div class='addtocartoverlay-products'>";
	    	if (responses != null && responses != undefined) {
	    		for (var i=0;i <= responses.length-1;i++) {
	            	var content = $(responses[i]).find('.cart-overlay-html .addtocartoverlay-products').html();
	            	dataContent += content;	
	            	var datax = $(responses[i]).find('.cart-overlay-html .addtocartoverlay-products').data('addtocart');
					Object.keys(data).forEach(function(key) {
    					if(Array.isArray(data[key]) && datax.hasOwnProperty(key)){
    						$.merge(data[key],datax[key]);
    					}
					});	            		            	
	            }
	    		dataContent += "</div>";
	    		var $dataContent = $(dataContent);
	    		$(overlayContent).find('.addtocartoverlay-products').removeClass("slick-initialized slick-slider").empty().append($dataContent.html());
	    		$(overlayContent).find('.addtocartoverlay-products').addClass('overlay-product-slick');
	    		$(overlayContent).find('.addtocartoverlay-subtotals').html(totalUpdatedPriceQty); 	    		
	    	}
	    	//tealium event

	    	if($('input[name="addallevent"]').length > 0 && $('input[name="addallevent"]').val() == "true"){
    			data.event_name = 'product_add_all';
    		}else{
    			data.event_name = 'product_add';
    		}
	    	if(window.utag_data && window.utag_data.page_name) {
	    		data.product_cart_location = window.utag_data.page_name;
	    		if(window.utag_data.page_name == 'mix-and-match'){
	    			var collectionId = [];
	    			if( typeof(data)!= 'undefined' && typeof(data.product_sku)!= 'undefined' ) {
	    	    		prodID = data.product_sku[0];
	    			}else if( typeof(data)!= 'undefined' && typeof(data.product_id)!= 'undefined' ){
	    	    		prodID = data.product_id[0];
	    	    	}
	    			var collectionVal = 'mixMatch_'+prodID;
		    		collectionId.push(collectionVal);
		    		data.collection_id = collectionId;
	    		}
	    	}
	    	
	    	if( $('.pdp-main').hasClass('standardproductset') ){
	    		var collectionId = [];
	    		var collectionVal = 'coll_'+ $('.product-detail').data('prodsetid');
	    		collectionId.push(collectionVal);
	    		data.collection_id = collectionId;
	    	}
	    	if(document.URL.indexOf("rrec=true") != -1){
	    		var recommended = [];
	    		for(var i = 0; data.product_quantity && i< data.product_quantity.length ; i++) {
	    		 recommended.push("1");
	    		}
	    		data.product_recommended_cart_addition = recommended;
	    	} else {
        		if(typeof (MERCH_UTILS) !== 'undefined') {   		
        			var findingMethod = MERCH_UTILS.getCookie("_productFindingMethodOSS");
        			if(findingMethod.includes('recommendation')){
        				var recommended = [];
	    				for(var i = 0; data.product_quantity && i< data.product_quantity.length ; i++) {
	    		 			recommended.push("1");
	    				}
	    				data.product_recommended_cart_addition = recommended;        				
        			}
        		}	    		
	    	}
	    	data.recommendations = 'true';
	    	if(data.bonus) {
	    		tealium.triggerEvent(data.bonus);
	    		delete data.bonus;
	    	}
	    	if($('#pdpMain').data('productinfo')){
                data.product_breadcrumb = $('#pdpMain').data('productinfo').product_breadcrumb;
                data.product_category = $('#pdpMain').data('productinfo').product_category;
                data.product_category_id = $('#pdpMain').data('productinfo').product_category_id;
                if (!(typeof $('#pdpMain').data('productinfo').product_navigation === "undefined")) {
                    data.product_navigation = $('#pdpMain').data('productinfo').product_navigation;
                }
	    	}
	    	tealium.triggerEvent(data);   	
	    	var continute= Resources.CONTINUE_SHOPPING;
				var checkout = Resources.CHECKOUT;
				if ($(window).width() <= 767) {
						continute = Resources.CHECKOUT;
						checkout = Resources.CONTINUE_SHOPPING;
				}
				var cartOverlay = dialog.create({
							options: {
									dialogClass: 'minicartpopup cart-overlay ',
									width: '740',
									height: '500',
									title: dialogtitle,
									position: { of: window, my: "center top+1%", at: "top+1%" },
									draggable: false,
									open: function () {											
											if ($(window).width() < 767) {
													$(window).scrollTop(0);
											}
											/* WCAG_Modal_focus_management */
											if($(window).width() < 768 && !$('.checkout-now').next('.view-bag').length){
												$(".view-bag").insertAfter(".checkout-now");
												$(".continue-shopping").insertAfter(".view-bag");
											}
											//add no image overlay for missing image selection
											if ($(this).find('.mini-cart-image').length !== 0) {
												var $imageDiv = $(this).find('.mini-cart-image').eq(0);
												console.log($imageDiv.find('img').length !== 0);
												console.log($imageDiv.find('img').data('isimagesameasmasterproduct') === 'true');
												if ($imageDiv.find('img').length !== 0 && $imageDiv.find('img').data('isimagesameasmasterproduct') === true) {
													$imageDiv.addClass('no-img-overlay');
												}
											}
											//force load certona image from lazyload functionality with dialog modal open
											if ($(this).find('img.p-image').length !== 0) {
													var $lazyloadImg = $(this).find('img.p-image');
													$lazyloadImg.each(function () {
															$(this).unveil().trigger('unveil');
													});
											}
											$('.continue-shopping').on('click', function (e) {
                                                    e.preventDefault();
                                                    tealium.triggerEvent({ event_name: "atb_continueshop_click" });
													image.loadZoom();
													if ($('#wrapper').hasClass('pt_cart') || $('#wrapper').hasClass('pt_cart_template_b')) {
															window.location.href = Urls.cartShow;
													} else {
															$(this).closest(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("click");
															if ($('.quick-view').length > 0) {
																	$('.ui-dialog.quick-view').find('.ui-dialog-titlebar-close').trigger('click');
															}
													}
											});
											$('.checkout-now').on('click', function (e) {
													e.preventDefault();
													tealium.triggerEvent({ event_name: "atb_checkout_click" });
													var globaleCookie = util.getCookie('GlobalE_Data').length ? JSON.parse(decodeURIComponent(util.getCookie('GlobalE_Data'))) : '';
                									var globaleCookieCountry = globaleCookie && globaleCookie.countryISO;
													var geExcludedCountries = SitePreferences.GLOBALE_EXCLUDED_COUNTRIES;
													if(globaleCookieCountry && geExcludedCountries && geExcludedCountries.toLowerCase().indexOf(globaleCookieCountry.toLowerCase()) == -1){
														internationalshipping.directCheckoutInternationalFunc();
													}else{
														window.location.href = Urls.directCheckout;
													}													
											});
											$('.view-bag').on('click', function (e) {
                                                e.preventDefault();
                                                tealium.triggerEvent({ event_name: "atb_viewbag_click" });
												window.location.href = Urls.cartShow;
											});
											if ($('.cart-overlay').height() > $(window).height()) {
													$('.cart-overlay').addClass('cart-mini-overlay');
											}
											$(".cart-overlay img").load(function () {
													$(".ui-dialog-content:visible").each(function () {
															$(this).dialog("option", "position", $(this).dialog("option", "position"));
													});
											});
											$('.ui-widget-overlay').on('click', function () {
													if ($('.cart-overlay').is(':visible')) {
															$('.cart-overlay').find('.ui-dialog-titlebar-close').trigger('click');
													}
											});
																						
									}
							}
            });
            $(cartOverlay).children().remove();
			$(cartOverlay).append(overlayContent);
			cartOverlay.dialog("open");	    	
	    	
			//addclass to disable scroll on mobile cart overlay 
			// WCAG aria-modal added
    		if($('.cart-overlay').is(':visible')) {
				$('body').addClass('disable-scroll');
				$('.cart-overlay').attr('aria-modal','true');
			}
			
			// wraps slick arrows with <li> tags after slick initialization.
			$('.cart-overlay .overlay-product-slick').on('init breakpoint', function(){
				if($('.cart-overlay .overlay-product-slick').prop('nodeName') == 'UL')
				$($('.cart-overlay .overlay-product-slick').children("button.slick-prev, button.slick-next")).wrap("<li></li>");
			});
	    	
	    	$('.cart-overlay .overlay-product-slick').slick({
         	   dots: false,
         	   slidesToShow: 1,
         	   slidesToScroll: 1,
         	   responsive: [
         	     {
         	       breakpoint: 767,
         	       settings: {
         	         dots: true,
         	         arrows: false
         	       }
         	     }
         	   ]
            });
	    	
	    	if($('.cart-overlay').height() > $( window ).height()){
	    		$('.cart-overlay').addClass('cart-mini-overlay');
	    	}
	    	/*$('.special-productset-child-wrapper').slimScroll({
	    		height: '145px',
	    		railVisible: true,
	    		color: "#000",
	    		railColor: "#dddddd", 
	    		distance: '9px',
	    		alwaysVisible: true
	    	});*/
	    }
	};

module.exports = cartOverlay;
